/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as ProjectsProjectIdIndexRouteImport } from './routes/projects/$projectId/index'
import { Route as ProjectsProjectIdSitesIndexRouteImport } from './routes/projects/$projectId/sites/index'
import { Route as ProjectsProjectIdSitesAddRouteImport } from './routes/projects/$projectId/sites/add'
import { Route as ProjectsProjectIdSitesSiteIdRouteImport } from './routes/projects/$projectId/sites/$siteId'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const ProjectsProjectIdIndexRoute = ProjectsProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProjectsProjectIdSitesIndexRoute =
  ProjectsProjectIdSitesIndexRouteImport.update({
    id: '/sites/',
    path: '/sites/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdSitesAddRoute =
  ProjectsProjectIdSitesAddRouteImport.update({
    id: '/sites/add',
    path: '/sites/add',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdSitesSiteIdRoute =
  ProjectsProjectIdSitesSiteIdRouteImport.update({
    id: '/sites/$siteId',
    path: '/sites/$siteId',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/new': typeof ProjectsNewRoute
  '/projects': typeof ProjectsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/sites/$siteId': typeof ProjectsProjectIdSitesSiteIdRoute
  '/projects/$projectId/sites/add': typeof ProjectsProjectIdSitesAddRoute
  '/projects/$projectId/sites': typeof ProjectsProjectIdSitesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/projects/new': typeof ProjectsNewRoute
  '/projects': typeof ProjectsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/projects/$projectId': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/sites/$siteId': typeof ProjectsProjectIdSitesSiteIdRoute
  '/projects/$projectId/sites/add': typeof ProjectsProjectIdSitesAddRoute
  '/projects/$projectId/sites': typeof ProjectsProjectIdSitesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/new': typeof ProjectsNewRoute
  '/projects/': typeof ProjectsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/sites/$siteId': typeof ProjectsProjectIdSitesSiteIdRoute
  '/projects/$projectId/sites/add': typeof ProjectsProjectIdSitesAddRoute
  '/projects/$projectId/sites/': typeof ProjectsProjectIdSitesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/about'
    | '/auth'
    | '/auth/login'
    | '/projects/$projectId'
    | '/projects/new'
    | '/projects'
    | '/settings'
    | '/projects/$projectId/'
    | '/projects/$projectId/sites/$siteId'
    | '/projects/$projectId/sites/add'
    | '/projects/$projectId/sites'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/about'
    | '/auth'
    | '/auth/login'
    | '/projects/new'
    | '/projects'
    | '/settings'
    | '/projects/$projectId'
    | '/projects/$projectId/sites/$siteId'
    | '/projects/$projectId/sites/add'
    | '/projects/$projectId/sites'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/about'
    | '/auth'
    | '/auth/login'
    | '/projects/$projectId'
    | '/projects/new'
    | '/projects/'
    | '/settings/'
    | '/projects/$projectId/'
    | '/projects/$projectId/sites/$siteId'
    | '/projects/$projectId/sites/add'
    | '/projects/$projectId/sites/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  AboutRoute: typeof AboutRoute
  AuthRoute: typeof AuthRouteWithChildren
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRouteWithChildren
  ProjectsNewRoute: typeof ProjectsNewRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/projects/$projectId/': {
      id: '/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/sites/': {
      id: '/projects/$projectId/sites/'
      path: '/sites'
      fullPath: '/projects/$projectId/sites'
      preLoaderRoute: typeof ProjectsProjectIdSitesIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/sites/add': {
      id: '/projects/$projectId/sites/add'
      path: '/sites/add'
      fullPath: '/projects/$projectId/sites/add'
      preLoaderRoute: typeof ProjectsProjectIdSitesAddRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/sites/$siteId': {
      id: '/projects/$projectId/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/projects/$projectId/sites/$siteId'
      preLoaderRoute: typeof ProjectsProjectIdSitesSiteIdRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ProjectsProjectIdRouteChildren {
  ProjectsProjectIdIndexRoute: typeof ProjectsProjectIdIndexRoute
  ProjectsProjectIdSitesSiteIdRoute: typeof ProjectsProjectIdSitesSiteIdRoute
  ProjectsProjectIdSitesAddRoute: typeof ProjectsProjectIdSitesAddRoute
  ProjectsProjectIdSitesIndexRoute: typeof ProjectsProjectIdSitesIndexRoute
}

const ProjectsProjectIdRouteChildren: ProjectsProjectIdRouteChildren = {
  ProjectsProjectIdIndexRoute: ProjectsProjectIdIndexRoute,
  ProjectsProjectIdSitesSiteIdRoute: ProjectsProjectIdSitesSiteIdRoute,
  ProjectsProjectIdSitesAddRoute: ProjectsProjectIdSitesAddRoute,
  ProjectsProjectIdSitesIndexRoute: ProjectsProjectIdSitesIndexRoute,
}

const ProjectsProjectIdRouteWithChildren =
  ProjectsProjectIdRoute._addFileChildren(ProjectsProjectIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  AboutRoute: AboutRoute,
  AuthRoute: AuthRouteWithChildren,
  ProjectsProjectIdRoute: ProjectsProjectIdRouteWithChildren,
  ProjectsNewRoute: ProjectsNewRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
